import React from "react";
import * as PropTypes from "prop-types";
import { css } from "@emotion/css";
import { withTranslation } from "react-i18next";

const classes = {
    comparisonRunName: css`
        background-color: plum;
        border-bottom: 3px dashed black;
        margin-left: 10px;
    `,
    container: css`
        display: flex;
    `,
    runName: css`
        background-color: lavender;
        border-bottom: 3px solid black;
        margin-left: 10px;
    `,
};

const ChartsComparisonLegend = ({ t, ...rest }) => {
    const suffix1 = rest.countryOrRegionName1; /// rest.countryNumericCode1 || rest.region1 || "";
    const suffix2 = rest.countryOrRegionName2; // rest.countryNumericCode2 || rest.region2 || "";

    return (
        <div className={classes.container}>
            <div>{t("Legend:")}</div>
            <div className={classes.runName}>
                {rest.runName} ({suffix1})
            </div>
            <div className={classes.comparisonRunName}>
                {rest.comparisonRunName} ({suffix2})
            </div>
        </div>
    );
};

ChartsComparisonLegend.propTypes = {
    runName: PropTypes.string,
    comparisonRunName: PropTypes.string,
    region1: PropTypes.string,
    region2: PropTypes.string,
    countryNumericCode1: PropTypes.number,
    countryNumericCode2: PropTypes.number,
    countryOrRegionName1: PropTypes.string,
    countryOrRegionName2: PropTypes.string,
};

export default withTranslation()(ChartsComparisonLegend);
